import React, { useState, useEffect, useMemo } from "react";
import Helpers from "../../helpers/shared.helper";
import Delete from "../../assets/img/Delete.svg";
import Storage from "../../services/storage.service";
import DeletePopup from "./storefront-delete-popup.js";
import Settings from "../../services/settings.service";
import Translations from "../../services/translation.service";
import Offers from "../../services/offers.service";
import Spinner from "../../views/shared/line.spinner"

const OfferCard = ({
  objKey = "",
  offer,
  translationKeys,
  prefix,
  selectedCard,
  appliedOffer = {},
  fetchOffers,
}) => {
  const [poOfferIcon, setPoOfferIcon] = useState({});
  const [isDeletePopup, setDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const isOfferError = (data) => {
    return !(selectedCard?.Promotions?.some((item) => item.PromotionCode === data.PromotionId) || false) && offer.IsApplied
  }

  const toggleDeleteModal = () => {
    setDeletePopup((prev) => !prev);
  };

  const handleApplyPromoCode = (PromotionId, isApplied, key) => {
    setLoading(true)
    Storage.clear("pre-defined-plan-selected")
    if (isApplied) {
      if (Storage.get("latest_offer_code_selected", true) === PromotionId) {
        Storage.clear("latest_offer_code_selected")
      }
      Offers.removeOffer(PromotionId)
        .then((response) => {
          fetchOffers().then(() => {
            setLoading(false)
          }).catch((err) => {
            setLoading(false)
          });
        })
        .catch((err) => {
          setLoading(false)
        });
    } else {
      Storage.set("latest_offer_code_selected", PromotionId, true)
      Storage.set("is_custom_card_selected", false, true)
      let number = JSON.parse(Storage.get("reserved_number_local", true));
      Offers.applyOffer(PromotionId, number?.MSISDN || null)
        .then((response) => {
          fetchOffers().then(() => {
            setLoading(false)
          }).catch((err) => {
            setLoading(false)
          });
        })
        .catch((err) => {
          setLoading(false)
        });
    }
  };

  const timeDuration = (duration) => {
    let durationField = "";
    if (duration === -1) {
      //If unlimited
      durationField = translationKeys[prefix + "unlimited"];
    } else {
      durationField = Helpers.monthsInDay(duration);

      if (durationField === 1) {
        durationField += " " + translationKeys[prefix + "month"];
      } else {
        durationField += " " + translationKeys[prefix + "months"];
      }
    }
    return durationField;
  };

  useEffect(() => {
    let offerIcon = JSON.parse(Storage.get('offers_images', true));
    if (offerIcon) {
      setPoOfferIcon(offerIcon);
    }
  }, []);

  const checkIsDisabled = (offer) => {
    const storageAppliedOffer = JSON.parse(Storage.get("offer_applied_promotion_object", true) || "{}")
    const alreadyAppliedOffer = Object.keys(appliedOffer).length ? appliedOffer : storageAppliedOffer
    if (alreadyAppliedOffer[offer.GroupName] && offer.GroupName) {
      return alreadyAppliedOffer[offer.GroupName] !== offer.PromotionId
    }
    return false
  }

  const handleDeleteOffer = () => {
    if (itemToDelete) {
      handleApplyPromoCode(
        itemToDelete.PromotionId,
        itemToDelete.IsApplied,
        itemToDelete.GroupName
      )
    }
    toggleDeleteModal()
  }

  const offerImage = useMemo(() => {
    let url = ""
    const key = `${offer?.PromotionId}_offer_image_${Settings.language}`
    url = Helpers.getPOImageCommon("stf_offer_banner_images", key, Translations.activeLang, "") || ""
    return url
  }, [offer])

  return (
    <>
      {isDeletePopup && <DeletePopup
        onClose={toggleDeleteModal}
        onDelete={handleDeleteOffer}
      />}
      <div className="card-wrapper">
        {!!offerImage && (
          <img className="card-banner" src={offerImage} alt="banner" />
        )}
        <div className={`card ${!!offerImage && "banner"}`}>
          <div className="card-header">
            <div className="card-left-section">
              <img src={offer?.PromotionId ? poOfferIcon[`offer_${offer?.PromotionId}_selected`]?.url : "not found"} alt={"tower"} />
              <div className="card-title">
                <p className="title-upper">
                  {offer?.PromoCode
                    ? translationKeys[prefix + "Promo_code"] +
                    " (" +
                    offer?.PromoCode +
                    ")"
                    : translationKeys[
                    `applied_offer_title_${offer?.PromotionId}`
                    ]}
                </p>
                <p className="title-lower">
                  {timeDuration(offer.PromotionDuration)}
                </p>
              </div>
            </div>
            <div className="promo_button_wrapper">
              {
                isLoading ?
                  <Spinner /> :
                  <>
                    <button
                      className={`apply-button ${checkIsDisabled(offer) ? "" : "apply"} ${offer.IsApplied ? "applied" : ""}`}
                      disabled={offer.IsApplied || checkIsDisabled(offer)}
                      onClick={() => handleApplyPromoCode(
                        offer.PromotionId,
                        offer.IsApplied,
                        objKey
                      )
                      }
                    >
                      {offer.IsApplied ? translationKeys[prefix + "applied"] : translationKeys[prefix + "apply"]}
                    </button>
                    {offer.IsApplied && (
                      <img
                        src={Delete}
                        alt="Delete"
                        onClick={() => {
                          toggleDeleteModal()
                          setItemToDelete(offer)
                        }
                        }
                      />
                    )}
                  </>
              }
            </div>
          </div>
          <p className="card-lower-text">
            {translationKeys[`applied_offer_description_${offer?.PromotionId}`]}
          </p>
          {isOfferError(offer) && <p className="card-lower-text error">
            {translationKeys[prefix + "Not_available_with_current_plan_selection"]}
          </p>}
        </div>
      </div>
    </>
  );
};

export default OfferCard;
